import { useAuthContext } from "providers/Auth";
import { FC } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { Plus } from "untitledui-js-base";

type Props = {
  handleCopyLink: (link: string) => void;
  setShowAddUnitModal: (show: boolean) => void;
};

export const LayoutButtons: FC<Props> = ({
  handleCopyLink,
  setShowAddUnitModal
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const { type, partner } = useAuthContext();
  const { adminPrivileges } = type;

  if (!type.isSDK && type.isBoomScreen)
    return (
      <>
        {type.isBoomCRM ? (
          <Button
            variant={ButtonVariant.BASE}
            className="w-full md:w-auto"
            size={ButtonSize.SM}
            onClick={() => handleCopyLink(partner?.listing_url ?? "")}
          >
            Copy listings link
          </Button>
        ) : (
          <Button
            variant={ButtonVariant.BASE}
            className="w-full md:w-auto"
            size={ButtonSize.SM}
            onClick={() =>
              handleCopyLink(partner?.magic_link?.application_link ?? "")
            }
          >
            Copy portfolio link
          </Button>
        )}
        {adminPrivileges ? (
          <Button
            className="w-full md:w-auto"
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.SM}
            onClick={() => setShowAddUnitModal(true)}
            Icon={Plus}
          >
            Add {dictionary.Unit}
          </Button>
        ) : null}
      </>
    );

  if ((type.isManual || type.canManageEntitiesDirectly) && adminPrivileges)
    return (
      <Button
        className="w-full md:w-auto"
        variant={ButtonVariant.PRIMARY}
        size={ButtonSize.SM}
        onClick={() => setShowAddUnitModal(true)}
        Icon={Plus}
      >
        Add {dictionary.Unit}
      </Button>
    );

  return null;
};
